import React, { useRef, useState, useEffect } from "react";
import "./FeaturedDenimMills.scss";
import MillIcon from "../../../assets/images/denim/Factory.svg";

const ITEMS_PER_PAGE = 4;

const chunk = (arr, size) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, []);

const FeaturedDenimMills = ({ featuredMills = [] }) => {
  const pages = chunk(featuredMills, ITEMS_PER_PAGE);
  const scrollerRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const userInteracted = useRef(false);

  useEffect(() => {
    if (paused || userInteracted.current) return;

    const interval = setInterval(() => {
      const next = (current + 1) % pages.length;
      scrollToPage(next);
    }, 5000);

    return () => clearInterval(interval);
  }, [current, paused, pages.length]);

  const scrollToPage = index => {
    if (!scrollerRef.current) return;
    const page = scrollerRef.current.firstElementChild;
    if (!page) return;

    const gap = 12;
    const width = page.offsetWidth + gap;

    scrollerRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });

    setCurrent(index);
  };

  const handleScroll = () => {
    if (!scrollerRef.current) return;
    const page = scrollerRef.current.firstElementChild;
    if (!page) return;

    const gap = 12;
    const width = page.offsetWidth + gap;

    const index = Math.round(scrollerRef.current.scrollLeft / width);
    setCurrent(index);
  };

  return (
    <section className="featured_section">
      <div className="featured_section__inner">
        <h2 className="heading featured_section__heading">
          Denim Fabrics Supplier
        </h2>

        <div
          className="featured_section__content"
          ref={scrollerRef}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => !userInteracted.current && setPaused(false)}
          onTouchStart={() => {
            userInteracted.current = true;
            setPaused(true);
          }}
          onScroll={handleScroll}
        >
          {pages.map((group, pageIndex) => (
            <div key={pageIndex} className="featured_page">
              {group.map(item => (
                <a
                  key={item.id}
                  // href={item.millLink} // temporary disabled: redirection
                  target="_blank"
                  rel="noopener noreferrer"
                  className="featured_item"
                >
                  <div className="featured_item__top">
                    <img
                      src={item.backgroundImage}
                      alt={item.label}
                      className="featured_item__bg"
                    />

                    {item.logo && (
                      <img
                        src={item.logo}
                        alt={`${item.label} logo`}
                        className="featured_item__logo"
                      />
                    )}
                  </div>

                  <div className="featured_item__bottom">
                    <img src={MillIcon} alt="" />
                    <span className="featured_item__label">
                      {item.label}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          ))}
        </div>

        <div className="hero_radioContainer featured_radio_controller">
          {pages.map((_, index) => (
            <div
              key={index}
              className={`radioWrapper ${
                index === current ? "activeRadioWrapper" : ""
              }`}
              onClick={() => {
                userInteracted.current = true;
                setPaused(true);
                scrollToPage(index);
              }}
            >
              <input
                className={`herodot ${index === current ? "active" : ""}`}
                type="radio"
                name="featured_mills_slider"
                checked={index === current}
                readOnly
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedDenimMills;
